import React from "react";
import _ from "lodash";

import ModalBox from "components/ModalBox";
import Input from "components/Input";
import Select from "components/Select";
import RangeDatepicker from "components/RangeDatepicker";
import Button from "components/Button";
import NumbersRange from "./NumbersRange";
import FilterGenerator from "helpers/filter";

import "./style.scss";

interface IProps {
  visible: boolean;
  onCloseModal: () => void;
  isLoading: boolean;
  downloadFile: (format: string, type: string, filter: string) => void;
  roleIds: any[];
}

interface IState {
  data: any;
}

class DeliveriesModal extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      data: {}
    };
  }

  private renderFilter = () => {
    const { data } = this.state;
    const Q = new FilterGenerator();
    Q.and("PurchaseType", data.PurchaseType, "select");
    Q.and("HarvestYear", data.HarvestYear, "number");
    Q.and("FromOrderNumber", _.get(data, "OrderNumber.from"), "string");
    Q.and("TillOrderNumber", _.get(data, "OrderNumber.to"), "string");
    Q.and("FromInvoiceNumber", _.get(data, "InvoiceNumber.from"), "string");
    Q.and("TillInvoiceNumber", _.get(data, "InvoiceNumber.to"), "string");
    Q.and("FromPaymentDate", _.get(data, "PaymentDate.from"), "date");
    Q.and("TillPaymentDate", _.get(data, "PaymentDate.to"), "date");
    Q.and("FromVersionNumber", _.get(data, "VersionNumber.from"), "string");
    Q.and("TillVersionNumber", _.get(data, "VersionNumber.to"), "string");
    Q.and("CounterPartyNumber", data.CounterPartyNumber, "string");
    Q.and("CounterPartyName", data.CounterPartyName, "string");
    Q.and("ProductGroup", data.ProductGroup, "string");
    Q.and("Cultivar", data.Cultivar, "string");

    this.props.downloadFile("Excel", "Leveringen", Q.query);
  };

  private handleChange = (value, name) => {
    this.setState(prevState => ({ data: _.set(prevState.data, name, value) }));
  };

  private maskOnInput = (e, name) => {
    const value = e.target.validity.valid
      ? e.target.value
      : _.get(this.state.data, name, "");

    this.handleChange(value, name);
  };

  public render() {
    const { visible, onCloseModal, isLoading, roleIds } = this.props;
    const { data } = this.state;
    return (
      <ModalBox visible={visible} onCloseModal={onCloseModal}>
        <div className="modal-content">
          <Select
            label="PURCHASE_TYPE"
            containerClassName="report-row"
            options={roleIds}
            selectedOption={data.PurchaseType}
            onChange={value => this.handleChange(value, "PurchaseType")}
          />
          <Input
            label="HARVEST_YEAR"
            pattern="[0-9]*"
            maxLength={4}
            onChange={e => this.maskOnInput(e, "HarvestYear")}
            value={data.HarvestYear}
            containerClassName="report-row"
          />
          <NumbersRange
            label="ORDERS_NUMBER"
            handleChange={this.maskOnInput}
            name="OrderNumber"
            value={data.OrderNumber}
          />
          <NumbersRange
            label="INVOICES_NUMBER"
            handleChange={this.maskOnInput}
            name="InvoiceNumber"
            value={data.InvoiceNumber}
          />
          <RangeDatepicker
            label="PAYMENT_DATE"
            value={data.PaymentDate}
            name="PaymentDate"
            handleRangeChange={this.handleChange}
          />
          <NumbersRange
            label="SERIAL_NR"
            handleChange={this.maskOnInput}
            name="VersionNumber"
            value={data.VersionNumber}
          />
          <Input
            label="RELATION"
            pattern="[0-9]*"
            onChange={e => this.maskOnInput(e, "CounterPartyNumber")}
            value={data.CounterPartyNumber}
            containerClassName="report-row"
          />
          <Input
            label="COUNTERPARTY_NAME_REL"
            onChange={e =>
              this.handleChange(e.target.value, "CounterPartyName")
            }
            value={data.CounterPartyName}
            containerClassName="report-row"
          />
          <Input
            label="DELIVERIES_GENUS"
            onChange={e => this.handleChange(e.target.value, "ProductGroup")}
            value={data.ProductGroup}
            containerClassName="report-row"
          />
          <Input
            label="DELIVERIES_CULTIVAR"
            onChange={e => this.handleChange(e.target.value, "Cultivar")}
            value={data.Cultivar}
            containerClassName="report-row"
          />
        </div>
        <div className="btn-container">
          <Button
            id="download-reports-invoiced-delivery"
            kind="primary"
            onClick={this.renderFilter}
            isLoading={isLoading}
            disabled={isLoading}
          >
            {isLoading ? "LOADING" : "REPORTS_INVOICED_DELIVERY_OVERVIEW"}
          </Button>
        </div>
      </ModalBox>
    );
  }
}

export default DeliveriesModal;
